import React, { useState } from "react";
import Chip from "@mui/material/Chip";
import { useNavigate } from "react-router-dom";

const useProducts = () => {

    let navigate = useNavigate();

    const actions = {
        add: () => navigate("/productos/nuevo-producto"),
        edit: (id) => navigate(`/productos/${id}/editar-producto`),
        delete: true,
    };

    const renderStatusChip = (status) => {
        switch (status) {
            case 1:
                return <Chip size="small" color="secondary" label="Activo" variant="outlined"/>;
            case 0:
                return <Chip size="small" color="warning" label="Inactivo" variant="outlined"/>;
        }
    };

    return {
        actions, renderStatusChip
    }
};

export default useProducts;
